// Ya Tú Sabes — metro San Juan beach guide.
// The beaches themselves are Listing records (type "Beach"), so the guide is
// edited from the same screen as every other place. What lives here is the
// guide's own vocabulary, and the shape its views read.

/** Browse category the guide lives under, alongside the directory categories. */
export const BEACH_CATEGORY = "Beaches";

/** The guide's running order; a beach's region is its subcategory. */
export const BEACH_REGIONS = [
  { title: "Metropolitan San Juan", range: "Old San Juan to Ocean Park" },
  { title: "Eastern Metro Fringe", range: "Carolina & Loíza / Piñones" },
  { title: "Western Metro Fringe", range: "Toa Baja / Isla de Cabras" },
];

/** Activities a beach can offer — the "what do you want to do" dropdown reads this. */
export const BEACH_ACTIVITIES = [
  "Swimming",
  "Snorkeling & Sea Life",
  "Surfing & Bodyboarding",
  "Paddleboarding & Kayaking",
  "Kitesurfing & Windsports",
  "Picnic & Park Facilities",
  "Sea Glass & Scenery",
  "Beach Walks",
];

/** What sits within easy reach of the sand — the "nearby" dropdown reads this. */
export const BEACH_NEARBY_TAGS = [
  "Gastronomy",
  "Shopping",
  "Nightlife",
  "Historic & Culture",
  "Nature & Trails",
];

export const BEACH_GUIDE_INTRO =
  "While major stretches like Condado and Isla Verde get most of the spotlight, the San Juan metropolitan area (and its immediate neighbors in Piñones and Toa Baja) is packed with hidden coves, protected saltwater pools, and neighborhood sand pockets.";

// A nearby spot is stored as one line, "Name — note", so an editor writes it the
// way it reads. Name is everything before the first dash; the note is the rest.
const parseNearby = (entry) => {
  const [name, ...rest] = String(entry).split(" — ");
  return { name: name.trim(), note: rest.join(" — ").trim() };
};

/** A stored beach listing, in the shape the guide's cards and tables render. */
export const listingToBeach = (listing) => ({
  id: listing.id,
  // The link an editor set, so a saved beach is shared at the address its page
  // really answers to.
  link_tag: listing.link_tag,
  slug: listing.slug || listing.id,
  name: listing.name,
  // Carried so screens that list every kind of place the same way — the saved
  // list, a shared link — can show a beach without knowing it is one.
  category: listing.category || "",
  address: listing.address || listing.beach_area || "",
  region: listing.subcategory || "",
  area: listing.beach_area || "",
  image: listing.cover_image || null,
  lat: typeof listing.latitude === "number" ? listing.latitude : null,
  lng: typeof listing.longitude === "number" ? listing.longitude : null,
  vibe: listing.beach_vibe || "",
  description: listing.description || "",
  bestFor: listing.beach_best_for || "",
  water: listing.beach_water || "",
  waterLevel: listing.beach_water_level || "",
  activities: listing.beach_activities || [],
  nearbyTags: listing.beach_nearby_tags || [],
  nearby: (listing.beach_nearby || []).map(parseNearby),
  amenities: listing.amenities || [],
});

/** Region first, then area — the guide's running order, east to west. */
const regionRank = (region) => {
  const i = BEACH_REGIONS.findIndex((r) => r.title === region);
  return i === -1 ? BEACH_REGIONS.length : i;
};

export const inGuideOrder = (beaches) =>
  [...beaches].sort(
    (a, b) =>
      regionRank(a.region) - regionRank(b.region) ||
      String(a.area).localeCompare(String(b.area)) ||
      String(a.name).localeCompare(String(b.name))
  );

export const coordsLabel = (beach) =>
  Number.isFinite(beach.lat) && Number.isFinite(beach.lng)
    ? `${beach.lat.toFixed(4)}° N, ${Math.abs(beach.lng).toFixed(4)}° W`
    : "";

export const directionsUrl = (beach) =>
  `https://www.google.com/maps/search/?api=1&query=${beach.lat},${beach.lng}`;